"use strict"

import React from "react"
import {observer} from "mobx-react"
import MobxReactForm from "mobx-react-form"
import validatorjs from "validatorjs"
import fields from "./formFields"
import bindings from "../../global/ui/globalUISchemeBindings"

import Grid from "@material-ui/core/Grid"

import XsInput from "../../global/ui/xsInput/xsInput"
import XsButton from "../../global/ui/xsButton/xsButton"
import XsRadioButtonGroup from "../../global/ui/xsRadioButtonGroup/xsRadioButtonGroup"

import UIStore from "../stores/UIStore"
import Cennik from "../cennik/cennik"
import RouterStore from "../../global/store/RouterStore"
import GlobalStore from "../../global/store/GlobalStore"
import InfoDialogStore from "../../global/store/InfoDialogStore"

import {FormattedMessage, injectIntl} from "react-intl"
import api from "../actions/api"
import {load} from "recaptcha-v3"
import settings from "../../global/config/settings"

@injectIntl
@observer
export default class Home extends React.Component {
	constructor(props) {
		super(props)

		// GlobalStore.loadCL()

		const hooks = {
			onSubmit() {},
			onSuccess(form) {
				load(settings.SITE_KEY).then((recaptcha) => {
					recaptcha.execute("doctor_portal_request").then((recaptchaToken) => {
						api
							.sendEmail(form, recaptchaToken)
							.call()
							.then(() => {
								InfoDialogStore.open({
									content: `Požiadavka bola úspešne odoslaná`
								})
								form.reset()
							})
					})
				})
				// GlobalStore.registerDoctor(form)
			},
			onError() {
				GlobalStore.setNotificationMessage(props.intl.formatMessage({id: "Common.warning.message.emptyform"}))
			}
		}

		this.form = new MobxReactForm(fields.load(), {plugins: {dvr: validatorjs}, hooks, bindings})
	}

	componentDidMount() {
		let scripts = [
			"../public/scripts/jquery.min.js",
			"../public/scripts/popper.min.js",
			"../public/scripts/bootstrap.js",
			"../public/scripts/moment.min.js",
			"../public/scripts/moment-business.js",
			"../public/scripts/aos.js",
			"../public/scripts/clipboard.js",
			"../public/scripts/jquery.fancybox.min.js",
			"../public/scripts/flickity.pkgd.min.js",
			"../public/scripts/ion.rangeSlider.min.js",
			"../public/scripts/isotope.pkgd.min.js",

			"../public/scripts/jarallax.min.js",
			"../public/scripts/jarallax-video.min.js",
			"../public/scripts/jarallax-element.min.js",
			"../public/scripts/jquery.countdown.min.js",
			"../public/scripts/plyr.polyfilled.min.js",
			"../public/scripts/prism.js",
			"../public/scripts/scrollMonitor.js",
			"../public/scripts/smooth-scroll.polyfills.js",
			"../public/scripts/twitterFetcher_min.js",
			"../public/scripts/typed.min.js",
			"../public/scripts/theme.js",
			"../public/scripts/controller.js",

			"../public/scripts/sweetalert.min.js",
			"../public/scripts/maine.js"
		]

		let counter = 0

		for (let i = 0; i < scripts.length; i++) {
			const script = document.createElement("script")
			script.src = scripts[i]
			script.async = false
			script.onload = () => {
				counter++
				if (counter == scripts.length) {
					UIStore.loading = false
				}
			}

			document.body.appendChild(script)
		}

		UIStore.scrollTo()

		document.querySelector("body").classList.add("loaded")
	}

	componentWillUnmount() {
		let scripts = document.getElementsByTagName("script")
		for (let i = 0; i < scripts.length; i++) {
			scripts[i].parentNode.removeChild(scripts[i])
		}
	}

	render() {
		return (
			<React.Fragment>
				{UIStore.loading ? (
					<div className="loader">
						<div className="loading-animation"></div>
					</div>
				) : (
					<React.Fragment>
						{/* NAV */}
						<div className="navbar-container bg-primary" style={{height: "100px"}}>
							<nav
								className="navbar navbar-expand-lg navbar-dark bg-primary fixed"
								style={{height: "100px"}}
								data-sticky="top"
							>
								<div className="container">
									<img
										className="pointer"
										onClick={() => RouterStore.push("./")}
										src="public/images/logo-white.png"
										alt="ambee DIGITÁLNY ASISTENT"
										title="ambee | Moderný ambulatný systém"
									/>

									<button
										className="navbar-toggler"
										type="button"
										data-toggle="collapse"
										data-target=".navbar-collapse"
										aria-expanded="false"
										aria-label="Toggle navigation"
									>
										<svg
											className="icon"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M3 17C3 17.5523 3.44772 18 4 18H20C20.5523 18 21 17.5523 21 17V17C21 16.4477 20.5523 16 20 16H4C3.44772 16 3 16.4477 3 17V17ZM3 12C3 12.5523 3.44772 13 4 13H20C20.5523 13 21 12.5523 21 12V12C21 11.4477 20.5523 11 20 11H4C3.44772 11 3 11.4477 3 12V12ZM4 6C3.44772 6 3 6.44772 3 7V7C3 7.55228 3.44772 8 4 8H20C20.5523 8 21 7.55228 21 7V7C21 6.44772 20.5523 6 20 6H4Z"
												fill="#212529"
											/>
										</svg>
									</button>
									<div className="collapse navbar-collapse justify-content-end" style={{overflow: "visible"}}>
										<div className="py-2 py-lg-0">
											<ul className="navbar-nav">
												<li className="nav-item">
													<a
														className="nav-link pointer"
														aria-expanded="false"
														aria-haspopup="false"
														onClick={() => {
															RouterStore.push("./")
															UIStore.scrollName = "vyhody"
														}}
													>
														VÝHODY
													</a>
												</li>
												<li className="nav-item">
													<a
														className="nav-link pointer"
														aria-expanded="false"
														aria-haspopup="false"
														onClick={() => {
															RouterStore.push("./")
															UIStore.scrollName = "dokumentacia"
														}}
													>
														DOKUMENTÁCIA
													</a>
												</li>
												<li className="nav-item">
													<a
														className="nav-link pointer"
														aria-expanded="false"
														aria-haspopup="false"
														onClick={() => {
															RouterStore.push("./")
															UIStore.scrollName = "referencie"
														}}
													>
														REFERENCIE
													</a>
												</li>
												<li className="nav-item">
													<a
														className="nav-link pointer"
														aria-expanded="false"
														aria-haspopup="false"
														onClick={() => {
															RouterStore.push("./")
															UIStore.scrollName = "cennik"
														}}
													>
														CENNÍK
													</a>
												</li>
												<li className="nav-item dropdown">
													<a
														href="#"
														className="nav-link dropdown-toggle"
														data-toggle="dropdown-grid"
														aria-expanded="false"
														aria-haspopup="true"
													>
														POMOC A PODPORA
													</a>
													<div className="dropdown-menu row">
														<div className="col-auto px-0" data-dropdown-content>
															<div className="bg-white rounded border shadow-lg o-hidden">
																<div className="p-3">
																	<h6 className="mb-0">
																		HELP DESK <b>+421 911 34 19 19</b>
																	</h6>
																	<p className="text-muted">
																		PO - PIA <b>08:00</b> - <b>16:00</b>
																	</p>
																	<div className="text-small text-muted">Zavolajte! Poradíme, pomôžeme.</div>
																</div>
																<div className="list-group list-group-flush">
																	<a
																		onClick={() => {
																			RouterStore.push("./dokumentacia")
																			UIStore.dokumentacia = ""
																		}}
																		className="list-group-item list-group-item-action d-flex align-items-center p-3 pointer"
																	>
																		<svg
																			className="icon icon-md"
																			width="24px"
																			height="24px"
																			viewBox="0 0 24 24"
																			version="1.1"
																			xmlns="http://www.w3.org/2000/svg"
																			// xmlns:xlink="http://www.w3.org/1999/xlink"
																		>
																			<title>Icon DOCS</title>
																			<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
																				<polygon points="0 0 24 0 24 24 0 24" opacity="0"></polygon>
																				<path
																					d="M4.85714286,1 L11.7364114,1 C12.0910962,1 12.4343066,1.12568431 12.7051108,1.35473959 L17.4686994,5.3839416 C17.8056532,5.66894833 18,6.08787823 18,6.52920201 L18,19.0833333 C18,20.8738751 17.9795521,21 16.1428571,21 L4.85714286,21 C3.02044787,21 3,20.8738751 3,19.0833333 L3,2.91666667 C3,1.12612489 3.02044787,1 4.85714286,1 Z M8,12 C7.44771525,12 7,12.4477153 7,13 C7,13.5522847 7.44771525,14 8,14 L15,14 C15.5522847,14 16,13.5522847 16,13 C16,12.4477153 15.5522847,12 15,12 L8,12 Z M8,16 C7.44771525,16 7,16.4477153 7,17 C7,17.5522847 7.44771525,18 8,18 L11,18 C11.5522847,18 12,17.5522847 12,17 C12,16.4477153 11.5522847,16 11,16 L8,16 Z"
																					fill="#000000"
																					fillRule="nonzero"
																					opacity="0.3"
																				></path>
																				<path
																					d="M6.85714286,3 L14.7364114,3 C15.0910962,3 15.4343066,3.12568431 15.7051108,3.35473959 L20.4686994,7.3839416 C20.8056532,7.66894833 21,8.08787823 21,8.52920201 L21,21.0833333 C21,22.8738751 20.9795521,23 19.1428571,23 L6.85714286,23 C5.02044787,23 5,22.8738751 5,21.0833333 L5,4.91666667 C5,3.12612489 5.02044787,3 6.85714286,3 Z M8,12 C7.44771525,12 7,12.4477153 7,13 C7,13.5522847 7.44771525,14 8,14 L15,14 C15.5522847,14 16,13.5522847 16,13 C16,12.4477153 15.5522847,12 15,12 L8,12 Z M8,16 C7.44771525,16 7,16.4477153 7,17 C7,17.5522847 7.44771525,18 8,18 L11,18 C11.5522847,18 12,17.5522847 12,17 C12,16.4477153 11.5522847,16 11,16 L8,16 Z"
																					fill="#000000"
																					fillRule="nonzero"
																				></path>
																			</g>
																		</svg>
																		<div className="text-body ml-3">
																			<span>Dokumentácia</span>
																			<div className="text-small text-muted">Všetko, čo pri používaní potrebujete</div>
																		</div>
																	</a>
																	<a
																		onClick={() => RouterStore.push("./faq")}
																		className="list-group-item list-group-item-action d-flex align-items-center p-3 pointer"
																	>
																		<svg
																			className="icon icon-md"
																			width="24px"
																			height="24px"
																			viewBox="0 0 24 24"
																			version="1.1"
																			xmlns="http://www.w3.org/2000/svg"
																			// xmlns:xlink="http://www.w3.org/1999/xlink"
																		>
																			<title>Icon FAQ</title>
																			<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
																				<rect opacity="0" x="0" y="0" width="24" height="24"></rect>
																				<path
																					d="M21.9999843,15.009808 L22.0249378,15 L22.0249378,19.5857864 C22.0249378,20.1380712 21.5772226,20.5857864 21.0249378,20.5857864 C20.7597213,20.5857864 20.5053674,20.4804296 20.317831,20.2928932 L18.0249378,18 L5,18 C3.34314575,18 2,16.6568542 2,15 L2,6 C2,4.34314575 3.34314575,3 5,3 L19,3 C20.6568542,3 22,4.34314575 22,6 L22,15 C22,15.0032706 21.9999948,15.0065399 21.9999843,15.009808 Z M6.16794971,10.5547002 C7.67758127,12.8191475 9.64566871,14 12,14 C14.3543313,14 16.3224187,12.8191475 17.8320503,10.5547002 C18.1384028,10.0951715 18.0142289,9.47430216 17.5547002,9.16794971 C17.0951715,8.86159725 16.4743022,8.98577112 16.1679497,9.4452998 C15.0109146,11.1808525 13.6456687,12 12,12 C10.3543313,12 8.9890854,11.1808525 7.83205029,9.4452998 C7.52569784,8.98577112 6.90482849,8.86159725 6.4452998,9.16794971 C5.98577112,9.47430216 5.86159725,10.0951715 6.16794971,10.5547002 Z"
																					fill="#000000"
																				></path>
																			</g>
																		</svg>
																		<div className="text-body ml-3">
																			<span>Máte otázky?</span>
																			<div className="text-small text-muted">
																				Pozrite si, čo sa často pýtajú lekári.
																			</div>
																		</div>
																	</a>
																</div>
															</div>
														</div>
													</div>
												</li>
												<li className="nav-item">
													<a
														className="nav-link pointer"
														onClick={() => {
															RouterStore.push("./somPacient")
															UIStore.status = ""
														}}
													>
														SOM PACIENT
													</a>
												</li>
											</ul>
										</div>
										<a
											onClick={() => {
												RouterStore.push("./")
												UIStore.scrollName = "kontakt"
											}}
											className="btn btn-white ml-lg-3 pointer"
										>
											Mám záujem
										</a>
									</div>
								</div>
							</nav>
						</div>

						<section className="bg-primary text-light o-hidden">
							<div className="container">
								<div className="row align-items-center min-vh-50">
									<div className="col-lg-6 text-center text-lg-left mb-4 mb-lg-0">
										<h1 className="display-3">
											Spoľahlivý asistent lekára. am<b>bee</b>.
										</h1>
										<div className="my-4">
											<p className="lead">
												Jednoduchý a intuitívny ambulantný softvér pre všeobecných lekárov a špecialistov. K dispozícii
												kedykoľvek a kdekoľvek.
											</p>
										</div>
										<a
											onClick={() => UIStore.scrollTo(UIStore.referencieRef.offsetTop)}
											className="btn btn-lg btn-white"
										>
											Zistiť viac
										</a>
									</div>
									<div className="col-lg-6 text-center" data-aos="fade-left">
										<img
											src="public/images/ambee-hero-image-calendar@2x.png"
											alt="ambee DIGITÁLNY ASISTEN pomáha pri plánovaní pacientov."
											className="min-vw-60"
										/>
										{/* saas-sketch-1.svg */}
									</div>
								</div>
							</div>
						</section>
						{/* HERO Image */}

						<section ref={(sec) => (UIStore.referencieRef = sec)} className="bg-primary-2-alt o-hidden">
							<div className="container">
								<div className="row align-items-center justify-content-around">
									<div className="col-md-5 pr-xl-4 mb-4 mb-md-0">
										{/* FIVE stars */}
										<div className="d-flex mb-3">
											<svg
												className="icon bg-primary-3"
												width="24"
												height="24"
												viewBox="0 0 24 24"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													fillRule="evenodd"
													clipRule="evenodd"
													d="M12.3616 17.7407L8.27722 19.888C7.78838 20.145 7.18375 19.957 6.92675 19.4682C6.82441 19.2735 6.7891 19.0505 6.82627 18.8338L7.60632 14.2858L4.30199 11.0648C3.90651 10.6793 3.89841 10.0462 4.28391 9.65073C4.43742 9.49325 4.63856 9.39076 4.8562 9.35913L9.42268 8.69559L11.4649 4.55766C11.7093 4.0624 12.3089 3.85906 12.8042 4.10349C13.0014 4.20082 13.161 4.36044 13.2583 4.55766L15.3005 8.69559L19.867 9.35913C20.4136 9.43855 20.7922 9.94599 20.7128 10.4925C20.6812 10.7102 20.5787 10.9113 20.4212 11.0648L17.1169 14.2858L17.8969 18.8338C17.9903 19.3781 17.6247 19.8951 17.0804 19.9884C16.8636 20.0256 16.6406 19.9903 16.446 19.888L12.3616 17.7407Z"
													fill="#212529"
												/>
											</svg>
											<svg
												className="icon bg-primary-3"
												width="24"
												height="24"
												viewBox="0 0 24 24"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													fillRule="evenodd"
													clipRule="evenodd"
													d="M12.3616 17.7407L8.27722 19.888C7.78838 20.145 7.18375 19.957 6.92675 19.4682C6.82441 19.2735 6.7891 19.0505 6.82627 18.8338L7.60632 14.2858L4.30199 11.0648C3.90651 10.6793 3.89841 10.0462 4.28391 9.65073C4.43742 9.49325 4.63856 9.39076 4.8562 9.35913L9.42268 8.69559L11.4649 4.55766C11.7093 4.0624 12.3089 3.85906 12.8042 4.10349C13.0014 4.20082 13.161 4.36044 13.2583 4.55766L15.3005 8.69559L19.867 9.35913C20.4136 9.43855 20.7922 9.94599 20.7128 10.4925C20.6812 10.7102 20.5787 10.9113 20.4212 11.0648L17.1169 14.2858L17.8969 18.8338C17.9903 19.3781 17.6247 19.8951 17.0804 19.9884C16.8636 20.0256 16.6406 19.9903 16.446 19.888L12.3616 17.7407Z"
													fill="#212529"
												/>
											</svg>
											<svg
												className="icon bg-primary-3"
												width="24"
												height="24"
												viewBox="0 0 24 24"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													fillRule="evenodd"
													clipRule="evenodd"
													d="M12.3616 17.7407L8.27722 19.888C7.78838 20.145 7.18375 19.957 6.92675 19.4682C6.82441 19.2735 6.7891 19.0505 6.82627 18.8338L7.60632 14.2858L4.30199 11.0648C3.90651 10.6793 3.89841 10.0462 4.28391 9.65073C4.43742 9.49325 4.63856 9.39076 4.8562 9.35913L9.42268 8.69559L11.4649 4.55766C11.7093 4.0624 12.3089 3.85906 12.8042 4.10349C13.0014 4.20082 13.161 4.36044 13.2583 4.55766L15.3005 8.69559L19.867 9.35913C20.4136 9.43855 20.7922 9.94599 20.7128 10.4925C20.6812 10.7102 20.5787 10.9113 20.4212 11.0648L17.1169 14.2858L17.8969 18.8338C17.9903 19.3781 17.6247 19.8951 17.0804 19.9884C16.8636 20.0256 16.6406 19.9903 16.446 19.888L12.3616 17.7407Z"
													fill="#212529"
												/>
											</svg>
											<svg
												className="icon bg-primary-3"
												width="24"
												height="24"
												viewBox="0 0 24 24"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													fillRule="evenodd"
													clipRule="evenodd"
													d="M12.3616 17.7407L8.27722 19.888C7.78838 20.145 7.18375 19.957 6.92675 19.4682C6.82441 19.2735 6.7891 19.0505 6.82627 18.8338L7.60632 14.2858L4.30199 11.0648C3.90651 10.6793 3.89841 10.0462 4.28391 9.65073C4.43742 9.49325 4.63856 9.39076 4.8562 9.35913L9.42268 8.69559L11.4649 4.55766C11.7093 4.0624 12.3089 3.85906 12.8042 4.10349C13.0014 4.20082 13.161 4.36044 13.2583 4.55766L15.3005 8.69559L19.867 9.35913C20.4136 9.43855 20.7922 9.94599 20.7128 10.4925C20.6812 10.7102 20.5787 10.9113 20.4212 11.0648L17.1169 14.2858L17.8969 18.8338C17.9903 19.3781 17.6247 19.8951 17.0804 19.9884C16.8636 20.0256 16.6406 19.9903 16.446 19.888L12.3616 17.7407Z"
													fill="#212529"
												/>
											</svg>
											<svg
												className="icon bg-primary-3"
												width="24"
												height="24"
												viewBox="0 0 24 24"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													fillRule="evenodd"
													clipRule="evenodd"
													d="M12.3616 17.7407L8.27722 19.888C7.78838 20.145 7.18375 19.957 6.92675 19.4682C6.82441 19.2735 6.7891 19.0505 6.82627 18.8338L7.60632 14.2858L4.30199 11.0648C3.90651 10.6793 3.89841 10.0462 4.28391 9.65073C4.43742 9.49325 4.63856 9.39076 4.8562 9.35913L9.42268 8.69559L11.4649 4.55766C11.7093 4.0624 12.3089 3.85906 12.8042 4.10349C13.0014 4.20082 13.161 4.36044 13.2583 4.55766L15.3005 8.69559L19.867 9.35913C20.4136 9.43855 20.7922 9.94599 20.7128 10.4925C20.6812 10.7102 20.5787 10.9113 20.4212 11.0648L17.1169 14.2858L17.8969 18.8338C17.9903 19.3781 17.6247 19.8951 17.0804 19.9884C16.8636 20.0256 16.6406 19.9903 16.446 19.888L12.3616 17.7407Z"
													fill="#212529"
												/>
											</svg>
										</div>

										<h3 className="h1 text-primary-3">
											&ldquo;Pomocník ambee je taký jednoduchý, až mám pocit, že sa s ním hrám. Konečne!&rdquo;
										</h3>
										<div className="mb-3">
											<b>MUDr. Michaela Macháčová</b>
											<br />
											všeobecný lekár pre dospelých
											<br />
											Topoľčany, <b>2&nbsp;496</b> pacientov
										</div>
										<a onClick={() => RouterStore.push("./referencie")} className="hover-arrow pointer blueColor">
											Zobraziť ďalšie referencie
										</a>
									</div>
									<div className="col-xl-5 col-md-6" data-aos="fade-left">
										<img
											src="public/images/ambee-testimonial-mudr-michaela-machacova.jpg"
											alt="MUDr. Michaela MACHÁČOVÁ, všeobecný lekár pre dospelých, Topoľčany"
											className="rounded shadow-lg layer-1"
										/>
										<div className="decoration top left scale-2 d-none d-md-block">
											<svg
												className="bg-primary"
												width="112"
												height="147"
												viewBox="0 0 112 147"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													d="M105.918 145.582C102.557 147.341 99.7192 147.135 97.2752 144.881C95.7962 145.108 94.5052 145.509 93.2322 145.456C90.7912 145.355 89.5462 144.135 89.3842 141.766C89.2302 139.516 89.2182 137.25 89.2652 134.995C89.3432 131.273 89.5212 127.554 89.6462 123.832C89.6732 123.042 89.6502 122.251 89.6502 121.504C88.3202 120.241 87.0452 119.116 85.8802 117.887C85.3602 117.336 84.8182 116.609 84.7122 115.899C84.3602 113.55 84.0232 111.175 84.0012 108.808C83.8922 96.976 84.0112 85.141 83.8042 73.312C83.6012 61.741 82.5742 50.23 80.0932 38.895C79.4702 36.042 78.6302 33.238 77.9412 30.4C77.7612 29.657 77.7692 28.868 77.6992 28.175C81.3872 26.105 81.9162 26.537 85.2752 28.529C87.8282 30.044 89.0192 32.123 89.9572 34.576C90.5682 36.174 91.5622 37.245 93.0332 38.056C95.5762 39.46 98.0172 41.052 100.59 42.401C101.488 42.873 102.125 43.378 102.436 44.312C103.571 47.712 104.733 51.104 105.825 54.518C106.583 56.892 106.421 59.507 108.011 61.699C108.54 62.428 108.197 63.749 108.384 64.775C108.741 66.731 109.349 68.652 109.575 70.619C110.214 76.146 110.804 81.671 111.124 87.243C111.589 95.331 111.798 103.416 111.913 111.509C111.944 113.763 111.876 116.029 111.683 118.275C111.195 123.958 110.621 129.633 110.052 135.308C109.988 135.96 109.927 136.767 109.534 137.206C107.408 139.588 107.096 142.736 105.918 145.582Z"
													fill="black"
												></path>
												<path
													d="M22.084 124.248C20.867 125.632 21.09 127.162 20.846 128.58C20.241 132.074 16.096 133.722 13.166 131.691C12.105 130.957 11.494 130.008 11.391 128.742C11.338 128.081 11.33 127.413 11.35 126.75C11.584 118.791 11.893 110.833 12.038 102.873C12.091 99.982 12.067 97.105 10.974 94.257C10.183 92.198 10.021 89.845 9.869 87.603C9.525 82.566 9.35503 77.517 9.12703 72.472C8.79903 65.173 8.46701 57.873 8.17201 50.573C8.10201 48.803 7.68202 47.138 6.81102 45.626C5.55302 43.442 4.19602 41.317 2.87302 39.173C1.97302 37.716 1.05901 36.269 0.187012 34.876C1.50901 31.249 4.251 32.453 6.83 32.645C6.928 31.814 7.11901 31.062 7.08601 30.32C6.92401 26.737 6.76401 23.151 6.48201 19.576C6.14801 15.348 5.69302 11.131 5.28902 6.90799C5.22502 6.24799 5.07202 5.58798 5.08202 4.92898C5.10202 3.64298 4.59001 1.977 6.06801 1.341C7.84701 0.574002 9.87503 -0.0789874 11.601 1.62701C12.591 2.60501 13.79 2.95101 15.087 3.35101C18.464 4.39301 21.347 6.169 22.413 9.866C23.108 12.276 23.737 14.707 24.395 17.129C24.637 18.024 24.737 18.987 25.137 19.806C26.703 23.011 26.705 26.416 26.662 29.86C26.564 37.422 26.939 44.965 27.758 52.486C27.815 53.008 27.946 53.617 27.752 54.057C26.305 57.332 27.272 60.795 26.938 64.154C26.663 66.903 26.709 69.675 27.178 72.471C27.518 74.498 27.539 76.66 26.873 78.78C26.494 79.992 26.654 81.412 26.74 82.728C27.199 89.75 27.674 96.773 28.217 103.79C28.617 108.959 28.295 114.128 28.362 119.296C28.401 122.267 27.292 123.49 24.223 124.028C23.838 124.096 23.426 124.002 23.032 124.028C22.771 124.042 22.518 124.143 22.084 124.248Z"
													fill="black"
												></path>
												<path
													d="M57.553 126.904C56.631 127.231 55.768 127.554 54.895 127.844C52.151 128.755 50.145 127.373 49.059 125.099C48.61 124.159 48.43 123.089 48.096 121.971C47.282 121.835 46.502 121.739 45.737 121.573C43.315 121.047 41.966 119.57 42.096 117.135C42.26 114.089 42.709 111.059 43.004 108.018C43.733 100.488 44.451 92.957 45.158 85.425C45.381 83.051 45.66 80.676 45.734 78.295C46.103 66.57 44.591 54.968 43.406 43.343C42.609 35.547 41.912 27.74 41.072 19.949C40.76 17.055 40.148 14.194 39.709 11.312C39.434 9.49597 38.934 7.67097 39.641 5.73797C41.844 4.66497 43.914 4.67596 45.912 6.28896C46.834 7.03396 47.85 7.66397 48.951 8.43597C49.709 10.674 50.025 13.261 51.961 15.093C53.127 18.893 54.4 22.664 55.42 26.503C56.061 28.916 56.32 31.431 56.742 33.857C57.859 34.504 58.123 33.346 58.715 32.995C60.453 31.96 62.069 31.607 63.844 32.989C64.768 33.707 65.93 34.12 67.078 34.719C67.078 37.275 67.156 39.893 67.06 42.504C66.894 47.011 66.615 51.514 66.394 56.018C66.146 61.053 66.165 66.118 65.609 71.118C64.539 80.728 63.945 90.369 63.441 100.013C63.101 106.518 62.621 112.998 61.867 119.464C61.709 120.821 61.555 122.038 59.935 122.582C59.304 122.793 58.775 123.619 58.429 124.284C58.012 125.084 57.838 126.011 57.553 126.904Z"
													fill="black"
												></path>
											</svg>
										</div>
										<div className="decoration bottom middle-x scale-2">
											<svg
												className="bg-primary-3"
												width="219"
												height="148"
												viewBox="0 0 219 148"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													d="M218.043 114.671C216.9 113.788 216.051 113.132 215.182 112.461C214.397 113.567 215.022 114.205 215.428 114.841C215.949 115.657 216.551 116.423 217.112 117.214C217.967 118.421 218.229 119.773 218.149 121.231C218.077 122.543 218.106 123.862 218.028 125.174C217.926 126.895 217.007 128.249 215.59 129.044C213.836 130.027 211.969 130.894 210.053 131.493C202.141 133.969 194.231 136.462 186.241 138.663C182.522 139.687 178.639 140.187 174.8 140.698C168.214 141.574 161.587 140.955 155.011 140.627C146.835 140.22 138.71 138.777 130.536 138.432C120.942 138.026 111.272 137.717 101.725 138.477C92.44 139.216 83.274 141.412 74.039 142.862C69.863 143.518 65.6249 143.781 61.4549 144.467C54.3069 145.645 47.0879 145.98 39.8979 146.675C33.5719 147.286 27.255 147.813 20.91 147.596C18.56 147.516 16.183 147.047 13.904 146.434C11.429 145.769 9.64195 144.108 8.41795 141.783C4.03895 133.465 1.74595 124.655 1.08795 115.249C0.556953 107.657 0.816948 100.09 0.720948 92.513C0.693948 90.229 0.986955 87.943 1.06896 85.656C1.13696 83.718 1.13695 81.777 1.12195 79.838C1.09695 77.03 0.976954 74.224 0.988954 71.417C1.01595 64.361 1.19395 57.306 1.11995 50.252C1.06895 45.498 0.547949 40.749 0.496949 35.995C0.445949 31.279 1.46196 26.706 3.27396 22.343C5.11596 17.905 7.58295 13.862 11.051 10.477C12.746 8.82098 14.426 7.147 16.074 5.444C19.344 2.067 23.4739 0.752996 28.0079 0.581996C30.1989 0.498996 32.404 0.763996 34.602 0.900996C37.942 1.109 41.2879 1.271 44.6199 1.582C51.1999 2.196 57.7899 2.76299 64.3429 3.60299C70.2589 4.36199 76.122 4.014 82.005 3.462C82.706 3.397 83.405 3.26401 84.109 3.23901C90.009 3.03301 95.9159 2.914 101.814 2.634C108.902 2.297 115.892 3.283 122.908 3.962C123.609 4.029 124.31 4.2 125.01 4.191C132.373 4.097 139.586 5.35199 146.813 6.52899C150.292 7.09499 153.764 7.41799 157.333 7.18099C164.981 6.67399 172.647 6.31399 180.312 6.17999C184.347 6.10999 188.406 6.526 192.431 6.94C196.296 7.336 199.833 8.87501 202.679 11.48C204.394 13.051 205.771 15.097 206.937 17.138C208.369 19.647 209.441 22.302 209.865 25.284C210.73 31.39 211.931 37.452 213.068 43.518C213.894 47.93 214.947 52.303 215.695 56.728C216.191 59.673 216.39 62.674 216.607 65.659C216.968 70.578 217.306 75.5 217.519 80.426C217.699 84.562 217.673 88.705 217.761 92.845C217.898 99.189 218.062 105.531 218.193 111.874C218.207 112.711 218.105 113.553 218.043 114.671ZM103.668 19.484C103.537 19.565 103.408 19.646 103.277 19.726C103.396 19.875 103.513 20.025 103.631 20.174C103.736 20.058 103.904 19.95 103.924 19.822C103.938 19.724 103.762 19.599 103.668 19.484Z"
													fill="black"
												></path>
											</svg>
										</div>
									</div>
								</div>
							</div>
						</section>
						{/* Referencie */}
						<section ref={(sec) => (UIStore.vyhodyRef = sec)}>
							<div className="container">
								<div className="row justify-content-center text-center mb-5">
									<div className="col-xl-8 col-lg-9">
										<h2 className="display-4 mx-xl-6">Overený v praxi.</h2>
										<p className="lead">
											am<b>bee</b> je výsledkom intenzívnej spolupráce s lekármi a sestrami. Jeho funkcie aj naďalej
											dolaďujeme presne podľa potrieb a požiadaviek. Aké sú jeho <b>hlavné výhody</b>?
										</p>
									</div>
								</div>

								<div className="row">
									<div className="col-md-6 col-lg-3 d-flex" data-aos="fade-up" data-aos-delay="100">
										<a className="card card-icon-2 card-body justify-content-between hover-shadow-3d">
											<div className="icon-round mb-3 mb-md-4 icon bg-primary-alt">
												<svg
													className="icon"
													width="24px"
													height="24px"
													viewBox="0 0 24 24"
													version="1.1"
													xmlns="http://www.w3.org/2000/svg"
												>
													<title>Bezpečnosť</title>
													<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
														<rect opacity="0" x="0" y="0" width="24" height="24"></rect>
														<path
															d="M8,17 C8.55228475,17 9,17.4477153 9,18 L9,21 C9,21.5522847 8.55228475,22 8,22 L3,22 C2.44771525,22 2,21.5522847 2,21 L2,18 C2,17.4477153 2.44771525,17 3,17 L3,16.5 C3,15.1192881 4.11928813,14 5.5,14 C6.88071187,14 8,15.1192881 8,16.5 L8,17 Z M5.5,15 C4.67157288,15 4,15.6715729 4,16.5 L4,17 L7,17 L7,16.5 C7,15.6715729 6.32842712,15 5.5,15 Z"
															fill="#000000"
															opacity="0.3"
														></path>
														<path
															d="M2,11.8650466 L2,6 C2,4.34314575 3.34314575,3 5,3 L19,3 C20.6568542,3 22,4.34314575 22,6 L22,15 C22,15.0032706 21.9999948,15.0065399 21.9999843,15.009808 L22.0249378,15 L22.0249378,19.5857864 C22.0249378,20.1380712 21.5772226,20.5857864 21.0249378,20.5857864 C20.7597213,20.5857864 20.5053674,20.4804296 20.317831,20.2928932 L18.0249378,18 L12.9835977,18 C12.7263047,14.0909841 9.47412135,11 5.5,11 C4.23590829,11 3.04485894,11.3127315 2,11.8650466 Z M6,7 C5.44771525,7 5,7.44771525 5,8 C5,8.55228475 5.44771525,9 6,9 L15,9 C15.5522847,9 16,8.55228475 16,8 C16,7.44771525 15.5522847,7 15,7 L6,7 Z"
															fill="#000000"
														></path>
													</g>
												</svg>
											</div>
											<h5 className="mb-0">
												<b>BEZPEČNOSŤ</b>
												<br />
												Dáta pacientov sú uložené bezpečne s pravidelným zálohovaním.
											</h5>
										</a>
									</div>
									<div className="col-md-6 col-lg-3 d-flex" data-aos="fade-up" data-aos-delay="200">
										<a className="card card-icon-2 card-body justify-content-between hover-shadow-3d bg-primary text-light">
											<div className="icon-round mb-3 mb-md-4 icon bg-white">
												<svg
													className="icon"
													width="24px"
													height="24px"
													viewBox="0 0 24 24"
													version="1.1"
													xmlns="http://www.w3.org/2000/svg"
												>
													<title>Jednoduchosť</title>
													<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
														<rect opacity="0" x="0" y="0" width="24" height="24"></rect>
														<rect fill="#000000" opacity="0.3" x="4" y="4" width="4" height="4" rx="2"></rect>
														<rect fill="#000000" x="4" y="10" width="4" height="4" rx="2"></rect>
														<rect fill="#000000" x="10" y="4" width="4" height="4" rx="2"></rect>
														<rect fill="#000000" x="10" y="10" width="4" height="4" rx="2"></rect>
														<rect fill="#000000" x="16" y="4" width="4" height="4" rx="2"></rect>
														<rect fill="#000000" x="16" y="10" width="4" height="4" rx="2"></rect>
														<rect fill="#000000" x="4" y="16" width="4" height="4" rx="2"></rect>
														<rect fill="#000000" x="10" y="16" width="4" height="4" rx="2"></rect>
														<rect fill="#000000" x="16" y="16" width="4" height="4" rx="2"></rect>
													</g>
												</svg>
											</div>
											<h5 className="mb-0">
												<b>JEDNODUCHOSŤ</b>
												<br />
												Najdôležitejšie informácie nájdete prehľadne na jednej obrazovke.
											</h5>
										</a>
									</div>
									<div className="col-md-6 col-lg-3 d-flex" data-aos="fade-up" data-aos-delay="100">
										<a className="card card-icon-2 card-body justify-content-between hover-shadow-3d">
											<div className="icon-round mb-3 mb-md-4 icon bg-primary-alt">
												<svg
													className="icon"
													width="24px"
													height="24px"
													viewBox="0 0 24 24"
													version="1.1"
													xmlns="http://www.w3.org/2000/svg"
												>
													<title>Prístup</title>
													<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
														<polygon points="0 0 24 0 24 24 0 24" opacity="0"></polygon>
														<path
															d="M18,14 C16.3431458,14 15,12.6568542 15,11 C15,9.34314575 16.3431458,8 18,8 C19.6568542,8 21,9.34314575 21,11 C21,12.6568542 19.6568542,14 18,14 Z M9,11 C6.790861,11 5,9.209139 5,7 C5,4.790861 6.790861,3 9,3 C11.209139,3 13,4.790861 13,7 C13,9.209139 11.209139,11 9,11 Z"
															fill="#000000"
															fillRule="nonzero"
															opacity="0.3"
														></path>
														<path
															d="M17.6011961,15.0006174 C21.0077043,15.0378534 23.7891749,16.7601418 23.9984937,20.4 C24.0069246,20.5466056 23.9984937,21 23.4559499,21 L19.6,21 C19.6,18.7490654 18.8562935,16.6718327 17.6011961,15.0006174 Z M0.00065168429,20.1992055 C0.388258525,15.4265159 4.26191235,13 8.98334134,13 C13.7712164,13 17.7048837,15.2931929 17.9979143,20.2 C18.0095879,20.3954741 17.9979143,21 17.2466999,21 C13.541124,21 8.03472472,21 0.727502227,21 C0.476712155,21 -0.0204617505,20.45918 0.00065168429,20.1992055 Z"
															fill="#000000"
															fillRule="nonzero"
														></path>
													</g>
												</svg>
											</div>
											<h5 className="mb-0">
												<b>PRÍSTUP</b>
												<br />
												Používajte ambee v ambulancii, či doma. Buďte vždy nablízku svojim pacientom.
											</h5>
										</a>
									</div>
									<div className="col-md-6 col-lg-3 d-flex" data-aos="fade-up" data-aos-delay="200">
										<a className="card card-icon-2 card-body justify-content-between hover-shadow-3d bg-primary text-light">
											<div className="icon-round mb-3 mb-md-4 icon bg-white">
												<svg
													className="icon"
													width="24px"
													height="24px"
													viewBox="0 0 24 24"
													version="1.1"
													xmlns="http://www.w3.org/2000/svg"
												>
													<title>Aktualizácie</title>
													<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
														<rect opacity="0" x="0" y="0" width="24" height="24"></rect>
														<path
															d="M9,10 L9,19 L10.1525987,19.3841996 C11.3761964,19.7920655 12.6575468,20 13.9473319,20 L17.5405883,20 C18.9706314,20 20.2018758,18.990621 20.4823303,17.5883484 L21.231529,13.8423552 C21.5564648,12.217676 20.5028146,10.6372006 18.8781353,10.3122648 C18.6189212,10.260422 18.353992,10.2430672 18.0902299,10.2606513 L14.5,10.5 L14.8641964,6.49383981 C14.9326895,5.74041495 14.3774427,5.07411874 13.6240179,5.00562558 C13.5827848,5.00187712 13.5414031,5 13.5,5 L13.5,5 C12.5694044,5 11.7070439,5.48826024 11.2282564,6.28623939 L9,10 Z"
															fill="#000000"
														></path>
														<rect fill="#000000" opacity="0.3" x="2" y="9" width="5" height="11" rx="1"></rect>
													</g>
												</svg>
											</div>
											<h5 className="mb-0">
												<b>AKTUALIZÁCIE</b>
												<br />
												Softvér sa aktualizuje priebežne, nemusíte na to myslieť.
											</h5>
										</a>
									</div>

									<div className="col-md-6 col-lg-3 d-flex" data-aos="fade-up" data-aos-delay="100">
										<a className="card card-icon-2 card-body justify-content-between hover-shadow-3d bg-primary text-light">
											<div className="icon-round mb-3 mb-md-4 icon bg-white">
												<svg
													className="icon"
													width="24px"
													height="24px"
													viewBox="0 0 24 24"
													version="1.1"
													xmlns="http://www.w3.org/2000/svg"
												>
													<title>Plánovanie</title>
													<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
														<rect opacity="0" x="0" y="0" width="24" height="24"></rect>
														<path
															d="M8,3 L8,3.5 C8,4.32842712 8.67157288,5 9.5,5 L14.5,5 C15.3284271,5 16,4.32842712 16,3.5 L16,3 L18,3 C19.1045695,3 20,3.8954305 20,5 L20,21 C20,22.1045695 19.1045695,23 18,23 L6,23 C4.8954305,23 4,22.1045695 4,21 L4,5 C4,3.8954305 4.8954305,3 6,3 L8,3 Z"
															fill="#000000"
															opacity="0.3"
														></path>
														<path
															d="M11,2 C11,1.44771525 11.4477153,1 12,1 C12.5522847,1 13,1.44771525 13,2 L14.5,2 C14.7761424,2 15,2.22385763 15,2.5 L15,3.5 C15,3.77614237 14.7761424,4 14.5,4 L9.5,4 C9.22385763,4 9,3.77614237 9,3.5 L9,2.5 C9,2.22385763 9.22385763,2 9.5,2 L11,2 Z"
															fill="#000000"
														></path>
														<rect fill="#000000" opacity="0.3" x="10" y="9" width="7" height="2" rx="1"></rect>
														<rect fill="#000000" opacity="0.3" x="7" y="9" width="2" height="2" rx="1"></rect>
														<rect fill="#000000" opacity="0.3" x="7" y="13" width="2" height="2" rx="1"></rect>
														<rect fill="#000000" opacity="0.3" x="10" y="13" width="7" height="2" rx="1"></rect>
														<rect fill="#000000" opacity="0.3" x="7" y="17" width="2" height="2" rx="1"></rect>
														<rect fill="#000000" opacity="0.3" x="10" y="17" width="7" height="2" rx="1"></rect>
													</g>
												</svg>
											</div>
											<h5 className="mb-0">
												<b>PLÁNOVANIE </b>
												<br />
												Jednoduchý systém na objednávanie a pripomenutie termínov.
											</h5>
										</a>
									</div>
									<div className="col-md-6 col-lg-3 d-flex" data-aos="fade-up" data-aos-delay="200">
										<a className="card card-icon-2 card-body justify-content-between hover-shadow-3d">
											<div className="icon-round mb-3 mb-md-4 icon bg-primary-alt">
												<svg
													className="icon"
													width="24px"
													height="24px"
													viewBox="0 0 24 24"
													version="1.1"
													xmlns="http://www.w3.org/2000/svg"
												>
													<title>Efektivita</title>
													<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
														<rect opacity="0" x="0" y="0" width="24" height="24"></rect>
														<path
															d="M12,21 C7.581722,21 4,17.418278 4,13 C4,8.581722 7.581722,5 12,5 C16.418278,5 20,8.581722 20,13 C20,17.418278 16.418278,21 12,21 Z"
															fill="#000000"
															opacity="0.3"
														></path>
														<path
															d="M13,5.06189375 C12.6724058,5.02104333 12.3386603,5 12,5 C11.6613397,5 11.3275942,5.02104333 11,5.06189375 L11,4 L10,4 C9.44771525,4 9,3.55228475 9,3 C9,2.44771525 9.44771525,2 10,2 L14,2 C14.5522847,2 15,2.44771525 15,3 C15,3.55228475 14.5522847,4 14,4 L13,4 L13,5.06189375 Z"
															fill="#000000"
														></path>
														<path
															d="M16.7099142,6.53272645 L17.5355339,5.70710678 C17.9260582,5.31658249 18.5592232,5.31658249 18.9497475,5.70710678 C19.3402718,6.09763107 19.3402718,6.73079605 18.9497475,7.12132034 L18.1671361,7.90393167 C17.7407802,7.38854954 17.251061,6.92750259 16.7099142,6.53272645 Z"
															fill="#000000"
														></path>
														<path
															d="M11.9630156,7.5 L12.0369844,7.5 C12.2982526,7.5 12.5154733,7.70115317 12.5355117,7.96165175 L12.9585886,13.4616518 C12.9797677,13.7369807 12.7737386,13.9773481 12.4984096,13.9985272 C12.4856504,13.9995087 12.4728582,14 12.4600614,14 L11.5399386,14 C11.2637963,14 11.0399386,13.7761424 11.0399386,13.5 C11.0399386,13.4872031 11.0404299,13.4744109 11.0414114,13.4616518 L11.4644883,7.96165175 C11.4845267,7.70115317 11.7017474,7.5 11.9630156,7.5 Z"
															fill="#000000"
														></path>
													</g>
												</svg>
											</div>
											<h5 className="mb-0">
												<b>EFEKTIVITA</b>
												<br />
												Lekár a sestra môžu pracovať súbežne. Bez akýchkoľvek obmedzení.
											</h5>
										</a>
									</div>
									<div className="col-md-6 col-lg-3 d-flex" data-aos="fade-up" data-aos-delay="100">
										<a className="card card-icon-2 card-body justify-content-between hover-shadow-3d bg-primary text-light">
											<div className="icon-round mb-3 mb-md-4 icon bg-white">
												<svg
													className="icon"
													width="24px"
													height="24px"
													viewBox="0 0 24 24"
													version="1.1"
													xmlns="http://www.w3.org/2000/svg"
												>
													<title>Bodovanie</title>
													<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
														<rect opacity="0" x="0" y="0" width="24" height="24"></rect>
														<path
															d="M5,2 L19,2 C20.1045695,2 21,2.8954305 21,4 L21,6 C21,7.1045695 20.1045695,8 19,8 L5,8 C3.8954305,8 3,7.1045695 3,6 L3,4 C3,2.8954305 3.8954305,2 5,2 Z M11,4 C10.4477153,4 10,4.44771525 10,5 C10,5.55228475 10.4477153,6 11,6 L16,6 C16.5522847,6 17,5.55228475 17,5 C17,4.44771525 16.5522847,4 16,4 L11,4 Z M7,6 C7.55228475,6 8,5.55228475 8,5 C8,4.44771525 7.55228475,4 7,4 C6.44771525,4 6,4.44771525 6,5 C6,5.55228475 6.44771525,6 7,6 Z"
															fill="#000000"
															opacity="0.3"
														></path>
														<path
															d="M5,9 L19,9 C20.1045695,9 21,9.8954305 21,11 L21,13 C21,14.1045695 20.1045695,15 19,15 L5,15 C3.8954305,15 3,14.1045695 3,13 L3,11 C3,9.8954305 3.8954305,9 5,9 Z M11,11 C10.4477153,11 10,11.4477153 10,12 C10,12.5522847 10.4477153,13 11,13 L16,13 C16.5522847,13 17,12.5522847 17,12 C17,11.4477153 16.5522847,11 16,11 L11,11 Z M7,13 C7.55228475,13 8,12.5522847 8,12 C8,11.4477153 7.55228475,11 7,11 C6.44771525,11 6,11.4477153 6,12 C6,12.5522847 6.44771525,13 7,13 Z"
															fill="#000000"
														></path>
														<path
															d="M5,16 L19,16 C20.1045695,16 21,16.8954305 21,18 L21,20 C21,21.1045695 20.1045695,22 19,22 L5,22 C3.8954305,22 3,21.1045695 3,20 L3,18 C3,16.8954305 3.8954305,16 5,16 Z M11,18 C10.4477153,18 10,18.4477153 10,19 C10,19.5522847 10.4477153,20 11,20 L16,20 C16.5522847,20 17,19.5522847 17,19 C17,18.4477153 16.5522847,18 16,18 L11,18 Z M7,20 C7.55228475,20 8,19.5522847 8,19 C8,18.4477153 7.55228475,18 7,18 C6.44771525,18 6,18.4477153 6,19 C6,19.5522847 6.44771525,20 7,20 Z"
															fill="#000000"
														></path>
													</g>
												</svg>
											</div>
											<h5 className="mb-0">
												<b>BODOVANIE</b>
												<br />
												Systém pomáha automatizovať bodovanie. Výrazne šetrí váš čas.
											</h5>
										</a>
									</div>
									<div className="col-md-6 col-lg-3 d-flex" data-aos="fade-up" data-aos-delay="200">
										<a className="card card-icon-2 card-body justify-content-between hover-shadow-3d">
											<div className="icon-round mb-3 mb-md-4 icon bg-primary-alt">
												<svg
													className="icon"
													width="24px"
													height="24px"
													viewBox="0 0 24 24"
													version="1.1"
													xmlns="http://www.w3.org/2000/svg"
												>
													<title>Legislatíva</title>
													<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
														<rect opacity="0" x="0" y="0" width="24" height="24"></rect>
														<path
															d="M4.875,20.75 C4.63541667,20.75 4.39583333,20.6541667 4.20416667,20.4625 L2.2875,18.5458333 C1.90416667,18.1625 1.90416667,17.5875 2.2875,17.2041667 C2.67083333,16.8208333 3.29375,16.8208333 3.62916667,17.2041667 L4.875,18.45 L8.0375,15.2875 C8.42083333,14.9041667 8.99583333,14.9041667 9.37916667,15.2875 C9.7625,15.6708333 9.7625,16.2458333 9.37916667,16.6291667 L5.54583333,20.4625 C5.35416667,20.6541667 5.11458333,20.75 4.875,20.75 Z"
															fill="#000000"
															fillRule="nonzero"
															opacity="0.3"
														></path>
														<path
															d="M2,11.8650466 L2,6 C2,4.34314575 3.34314575,3 5,3 L19,3 C20.6568542,3 22,4.34314575 22,6 L22,15 C22,15.0032706 21.9999948,15.0065399 21.9999843,15.009808 L22.0249378,15 L22.0249378,19.5857864 C22.0249378,20.1380712 21.5772226,20.5857864 21.0249378,20.5857864 C20.7597213,20.5857864 20.5053674,20.4804296 20.317831,20.2928932 L18.0249378,18 L12.9835977,18 C12.7263047,14.0909841 9.47412135,11 5.5,11 C4.23590829,11 3.04485894,11.3127315 2,11.8650466 Z M6,7 C5.44771525,7 5,7.44771525 5,8 C5,8.55228475 5.44771525,9 6,9 L15,9 C15.5522847,9 16,8.55228475 16,8 C16,7.44771525 15.5522847,7 15,7 L6,7 Z"
															fill="#000000"
														></path>
													</g>
												</svg>
											</div>
											<h5 className="mb-0">
												<b>LEGISLATÍVA</b>
												<br />
												Štandardom je pripojenie do ezdravie v súlade s legislatívou.
											</h5>
										</a>
									</div>
								</div>
							</div>
						</section>

						{/* All You Need Is ambee */}
						<section className="bg-primary">
							<div className="container">
								<div className="row justify-content-between align-items-center">
									<div className="col-md-6 mb-4 mb-md-0">
										{/* <div className="video-poster rounded layer-2" data-aos="fade-right">
											<div className="col-lg-12 col-xl-12">
												<div className="rounded o-hidden">
													<div
														className="plyr"
														dataplyrprovider="youtube"
														dataplyrembedid="https://www.youtube.com/watch?v=XzVeAxkhC1o"
													></div>
												</div>
											</div>
										</div> */}
										<iframe
											width="100%"
											height="360"
											frameBorder="0"
											style={{borderRadius: 20}}
											src={`https://www.youtube.com/embed/XzVeAxkhC1o`}
										></iframe>
									</div>
									<div className="col-md-6 col-lg-5" data-aos="fade">
										<h2 className="h1" style={{color: "white"}}>
											Príbeh am<b>bee</b>
										</h2>
										<p className="lead" style={{color: "white"}}>
											Dobrý lekár musí robiť v prvom rade dobrú medicínu. No rutinná prax v ambulancii je niekedy ďaleko
											od medicínskeho sna. Preto sme vyvinuli am<b>bee</b>.
										</p>
									</div>
								</div>
							</div>
						</section>
						<section className="pt-0 mt-6">
							<div className="container">
								<div className="row justify-content-around align-items-center">
									<div className="col-6 col-md-5 mb-4 mb-md-0">
										<img src="public/images/saas-sketch-6.svg" alt="Image" />
									</div>
									<div className="col-xl-5 col-md-6">
										<h3 className="h1">
											Funkcie am<b>bee</b>
										</h3>
										<div className="mt-4 mb-3">
											<div className="border-bottom pb-3 mb-3">
												<div
													data-target="#panel-3"
													className="accordion-panel-title"
													data-toggle="collapse"
													role="button"
													aria-expanded="true"
												>
													<span className="h6 mb-0">Karty pacientov</span>
													<svg
														className="icon"
														width="24"
														height="24"
														viewBox="0 0 24 24"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															d="M19 11H5C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13H19C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11Z"
															fill="#212529"
														/>
														<path
															d="M13 19L13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5L11 19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19Z"
															fill="#212529"
														/>
													</svg>
												</div>
												<div className="collapse show" id="panel-3">
													<div className="pt-3">
														<p className="mb-0">
															Prehľadné, ľahko dostupné a chronologicky usporiadané karty všetkých vašich pacientov budú
															vždy poruke. Najdôležitejšie údaje o pacientovi budú zobrazené prehľadne na jednom mieste.
														</p>
													</div>
												</div>
											</div>
											{/* <!-- karty pacientov --> */}
											<div className="border-bottom pb-3 mb-3">
												<div
													data-target="#panel-4"
													className="accordion-panel-title"
													data-toggle="collapse"
													role="button"
													aria-expanded="false"
												>
													<span className="h6 mb-0">Plánovanie</span>
													<svg
														className="icon"
														width="24"
														height="24"
														viewBox="0 0 24 24"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															d="M19 11H5C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13H19C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11Z"
															fill="#212529"
														/>
														<path
															d="M13 19L13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5L11 19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19Z"
															fill="#212529"
														/>
													</svg>
												</div>
												<div className="collapse" id="panel-4">
													<div className="pt-3">
														<p className="mb-0">
															Niektoré veci pokojne vypustite z hlavy a venujte čas pacientovi. S pomocou am<b>bee</b>:
														</p>
														<ul type="square" className="mt-3">
															<li>naplánujete si kontroly či štandardné vyšetrenia,</li>
															<li>zorganizujete preventívne prehliadky a očkovania,</li>
															<li>nájdete najvhodnejší termín pre vás a vášho pacienta,</li>
															<li>uvidíte plán pacientov na aktuálny deň, týždeň alebo mesiac,</li>
															<li>ušetríte svoj čas, aj čas vašich pacientov.</li>
														</ul>
													</div>
												</div>
											</div>
											{/* <!-- planovanie --> */}
											<div className="border-bottom pb-3 mb-3">
												<div
													data-target="#panel-5"
													className="accordion-panel-title"
													data-toggle="collapse"
													role="button"
													aria-expanded="false"
												>
													<span className="h6 mb-0">Poisťovne a legislatíva</span>
													<svg
														className="icon"
														width="24"
														height="24"
														viewBox="0 0 24 24"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															d="M19 11H5C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13H19C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11Z"
															fill="#212529"
														/>
														<path
															d="M13 19L13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5L11 19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19Z"
															fill="#212529"
														/>
													</svg>
												</div>
												<div className="collapse" id="panel-5">
													<div className="pt-3">
														<p className="mb-0">
															am<b>bee</b> je prepojený na všetky tri zdravotné poisťovne v súlade s ich požiadavkami a
															pravidlami. am<b>bee</b>
															vie:
														</p>
														<ul type="square" className="mt-3">
															<li>bezpečne a spoľahlivo komunikovať,</li>
															<li>vytvárať dávky s výkazmi,</li>
															<li>komunikovať s ezdravie v súlade s legislatívou,</li>
															<li>pripraviť mesačné zúčtovanie dát pre sociálnu poisťovňu.</li>
														</ul>
													</div>
												</div>
											</div>
											{/* <!-- poistovne a legislativa --> */}
											<div className="border-bottom pb-3 mb-3">
												<div
													data-target="#panel-6"
													className="accordion-panel-title"
													data-toggle="collapse"
													role="button"
													aria-expanded="false"
												>
													<span className="h6 mb-0">Šablóny dokumentov</span>
													<svg
														className="icon"
														width="24"
														height="24"
														viewBox="0 0 24 24"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															d="M19 11H5C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13H19C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11Z"
															fill="#212529"
														/>
														<path
															d="M13 19L13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5L11 19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19Z"
															fill="#212529"
														/>
													</svg>
												</div>
												<div className="collapse" id="panel-6">
													<div className="pt-3">
														<p className="mb-0">
															Šetria váš čas. Pre rýchlejšie vytvorenie a zápis zdravotných záznamov pacienta si môžete
															vytvoriť šablóny s preddefinovaným textom, ktoré viete jedným klikom zvoliť a použiť.
															Kostru dokumentu tak máte vždy poruke. Najčastejšie používané šablóny:
														</p>
														<ul type="square" className="mt-3">
															<li>dekurz,</li>
															<li>výmenný lístok,</li>
															<li>žiadosť o kúpeľnú liečbu,</li>
															<li>formulár pre preventívnu prehliadku,</li>
															<li>žiadanka na vyšetrenie (RTG, vyšetrenia krvi),</li>
															<li>anamnézy.</li>
														</ul>
													</div>
												</div>
											</div>
											{/* <!-- sablony dokumentov --> */}
											<div className="border-bottom pb-3 mb-3">
												<div
													data-target="#panel-7"
													className="accordion-panel-title"
													data-toggle="collapse"
													role="button"
													aria-expanded="false"
												>
													<span className="h6 mb-0">Prehľady</span>
													<svg
														className="icon"
														width="24"
														height="24"
														viewBox="0 0 24 24"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															d="M19 11H5C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13H19C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11Z"
															fill="#212529"
														/>
														<path
															d="M13 19L13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5L11 19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19Z"
															fill="#212529"
														/>
													</svg>
												</div>
												<div className="collapse" id="panel-7">
													<div className="pt-3">
														<p className="mb-0">
															Všetky prehľady, výkazy a štatistiky bez starostí. Je ich veľa, najčastejšie využívané sú
															tieto:
														</p>
														<ul type="square" className="mt-3">
															<li>prehľady o preventívnych prehliadkach,</li>
															<li>prehľady výkonov a vyšetrení,</li>
															<li>počet ošetrených pacientov podľa diagnózy,</li>
															<li>prehľad kapitovaných a nekapitovaných pacientov,</li>
															<li>prehľad predpísaných liekov a pomôcok,</li>
															<li>prehľad laboratórnych výsledkov,</li>
															<li>denný prehľad pacientov,</li>
															<li>prehľad odoslaných SMS pacientom,</li>
															<li>prehľady PN a OČR.</li>
														</ul>
													</div>
												</div>
											</div>
											{/* <!-- prehlady --> */}
											<div className="border-bottom pb-3 mb-3">
												<div
													data-target="#panel-8"
													className="accordion-panel-title"
													data-toggle="collapse"
													role="button"
													aria-expanded="false"
												>
													<span className="h6 mb-0">ezdravie</span>
													<svg
														className="icon"
														width="24"
														height="24"
														viewBox="0 0 24 24"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															d="M19 11H5C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13H19C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11Z"
															fill="#212529"
														/>
														<path
															d="M13 19L13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5L11 19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19Z"
															fill="#212529"
														/>
													</svg>
												</div>
												<div className="collapse" id="panel-8">
													<div className="pt-3">
														<p className="mb-2">
															am<b>bee</b> je certifikovaný a prepojený systém. Komunikuje na pozadí tak, aby ste s ním
															splnili legislatívne povinnosti. Je prepojený na všetky zdravotné poisťovne.
														</p>
														<p className="mb-0">
															Kartičku a čítačku musíte mať pripojenú, ostatné zabezpečí systém sám:
														</p>
														<ul type="square" className="mt-3">
															<li>overenie cez ePZP kartu lekára,</li>
															<li>integrácia na ezdravie a modul erecept,</li>
															<li>integrácia na Bezpečné lieky online,</li>
															<li>integrácia na erecept od VšZP a Union,</li>
															<li>po prihlásení a zadaní PIN kódu sa už nasledujúce 4 hodiny prihlasovať nemusíte.</li>
														</ul>
													</div>
												</div>
											</div>
											{/* <!-- ezdravie --> */}
										</div>
										<div className="text-small text-muted">
											Máte akékoľvek otázky?
											<a onClick={() => UIStore.scrollTo(UIStore.kontaktRef.offsetTop)} className="hover-arrow pointer">
												Spýtajte sa
											</a>
										</div>
									</div>
								</div>
							</div>
						</section>
						{/* Dokumentacia */}
						{/* <!-- Detailed Features --> */}

						<section ref={(sec) => (UIStore.dokumentacieRef = sec)} className="bg-primary-2-alt">
							<div className="container">
								<div className="row mb-4">
									<div className="col">
										<h3 className="h1">Dokumentácia</h3>
										<p className="lead">Dopĺňame ju priebežne. Je aktuálna, stručná a zrozumiteľná.</p>
									</div>
								</div>
								<div className="row">
									<div className="col-md-6 col-lg-4 d-flex" data-aos="fade-up" data-aos-delay="100">
										<a
											onClick={() => {
												RouterStore.push("./dokumentacia")
												UIStore.dokumentacia = "certifikaty"
											}}
											className="card card-body justify-content-between bg-primary text-light pointer"
										>
											<div className="d-flex justify-content-between mb-3">
												<div className="text-small d-flex">
													<div className="mr-2">DÔLEŽITÉ</div>
													<span className="opacity-70">9. januára 2019</span>
												</div>
												<span className="badge bg-primary-alt text-primary">
													<svg
														className="icon icon-sm bg-primary"
														width="24"
														height="24"
														viewBox="0 0 24 24"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															d="M16.5 5C14.8905 5 13.0082 6.82463 12 8C10.9918 6.82463 9.1095 5 7.5 5C4.651 5 3 7.22218 3 10.0504C3 13.1835 6 16.5 12 20C18 16.5 21 13.25 21 10.25C21 7.42177 19.349 5 16.5 5Z"
															fill="#212529"
														/>
													</svg>
													391
												</span>
											</div>
											<div>
												<h2>Certifikáty o overení zhody na ezdravie</h2>
												<span className="text-small opacity-70">Certifikáty a štandardy</span>
											</div>
										</a>
									</div>

									<div className="col-md-6 col-lg-4 d-flex" data-aos="fade-up" data-aos-delay="200">
										<div className="card">
											<a
												onClick={() => {
													RouterStore.push("./dokumentacia")
													UIStore.dokumentacia = "zacinameAmbee"
												}}
												className="pointer"
												title="Zobraziť dokument."
											>
												<img src="public/images/ambee-documentation-article.png" alt="Image" className="card-img-top" />
											</a>
											<div className="card-body d-flex flex-column">
												<div className="d-flex justify-content-between mb-3">
													<div className="text-small d-flex">
														<div className="mr-2">
															<a>Príručka</a>
														</div>
														<span className="text-muted">9. januára</span>
													</div>
													<span className="badge bg-primary-alt text-primary">
														<svg
															className="icon icon-sm bg-primary"
															width="24"
															height="24"
															viewBox="0 0 24 24"
															fill="none"
															xmlns="http://www.w3.org/2000/svg"
														>
															<path
																d="M16.5 5C14.8905 5 13.0082 6.82463 12 8C10.9918 6.82463 9.1095 5 7.5 5C4.651 5 3 7.22218 3 10.0504C3 13.1835 6 16.5 12 20C18 16.5 21 13.25 21 10.25C21 7.42177 19.349 5 16.5 5Z"
																fill="#212529"
															/>
														</svg>
														812
													</span>
												</div>
												<a
													onClick={() => {
														RouterStore.push("./dokumentacia")
														UIStore.dokumentacia = "zacinameAmbee"
													}}
													className="pointer"
													title="Zobraziť dokument."
												>
													<h4>
														Začíname s am<b>bee</b>
													</h4>
												</a>
												<p className="flex-grow-1">
													S nami sa nestratíte. Príručka vás prevedie prvými krokmi v aplikácii. am<b>bee</b> je váš
													asistent.
												</p>
												<div className="d-flex align-items-center mt-3">
													<img src="public/images/avatars/mc-avatar.png" alt="Image" className="avatar avatar-sm" />
													<div className="ml-1">
														<span className="text-small text-muted">Autor</span>
														<span className="text-small">Martin CINGEL</span>
													</div>
												</div>
											</div>
										</div>
									</div>

									<div className="col-md-6 col-lg-4" data-aos="fade-up" data-aos-delay="100">
										<div className="card hover-shadow-3d">
											<a
												onClick={() => {
													RouterStore.push("./dokumentacia")
													UIStore.dokumentacia = "zacinameAmbee"
												}}
												className="pointer"
												title="Prečítajte si, ako si môžete zjednodušiť svoju prácu a ušetriť čas."
											>
												<img src="public/images/ambee-documentation-article.png" alt="Image" className="card-img-top" />
											</a>
											<div className="card-body d-flex flex-column">
												<div className="d-flex justify-content-between mb-3">
													<div className="text-small d-flex">
														<div className="mr-2">
															<a>Príručka</a>
														</div>
														<span className="text-muted">27. marca</span>
													</div>
													<span className="badge bg-primary-alt text-primary">
														<svg
															className="icon icon-sm bg-primary"
															width="24"
															height="24"
															viewBox="0 0 24 24"
															fill="none"
															xmlns="http://www.w3.org/2000/svg"
														>
															<path
																d="M16.5 5C14.8905 5 13.0082 6.82463 12 8C10.9918 6.82463 9.1095 5 7.5 5C4.651 5 3 7.22218 3 10.0504C3 13.1835 6 16.5 12 20C18 16.5 21 13.25 21 10.25C21 7.42177 19.349 5 16.5 5Z"
																fill="#212529"
															/>
														</svg>
														24
													</span>
												</div>
												<a
													onClick={() => {
														RouterStore.push("./dokumentacia")
														UIStore.dokumentacia = "zacinameAmbee"
													}}
													className="pointer"
												>
													<h4>Plánovanie pacientov</h4>
												</a>
												<p className="flex-grow-1">
													Poradíme vám, ako si môžete zjednodušiť svoju prácu a ušetriť čas. Dozviete sa aj o
													automatizácii procesu.
												</p>
												<div className="d-flex align-items-center mt-3">
													<img src="public/images/avatars/mc-avatar.png" alt="Image" className="avatar avatar-sm" />
													<div className="ml-1">
														<span className="text-small text-muted">Autor</span>
														<span className="text-small">Martin CINGEL</span>
													</div>
												</div>
											</div>
										</div>
									</div>
									{/* <!-- Prirucka --> */}
								</div>
								<div className="row">
									<div className="col mt-3">
										<div className="text-small text-muted">
											Hľadáte niečo špecifické?
											<a
												onClick={() => {
													RouterStore.push("./dokumentacia")
													UIStore.dokumentacia = ""
												}}
												className="hover-arrow pointer blueColor"
											>
												Zobraziť celú dokumentáciu
											</a>
										</div>
									</div>
								</div>
							</div>
						</section>

						{/* <!-- Cennik --> */}
						<Cennik />

						<section ref={(sec) => (UIStore.kontaktRef = sec)} className="bg-primary-3 text-light o-hidden">
							<div className="container layer-1">
								<div className="row justify-content-center text-center mb-5">
									<div className="col-xl-8 col-lg-9">
										<h2 className="display-4 mx-xl-6">Začnite už dnes</h2>
										<p className="lead">
											Môžete si o am<b>bee</b> čítať. Môžete si informácie overiť u kolegov. Najlepšie urobíte, ak si
											nájdete zopár minút a am<b>bee </b>
											si skúsite sami.
										</p>
									</div>
								</div>
								{/* <Grid container justify="center">
									<Grid container item xs={8} spacing={24}>
										<Grid item xs={6}>
											<XsInput field={this.form.$("first_name")} />
										</Grid>
										<Grid item xs={6}>
											<XsInput field={this.form.$("last_name")} />
										</Grid>
										<Grid item xs={6}>
											<XsSearchSelect field={this.form.$("title_before")} items={GlobalStore.titleCL} />
										</Grid>
										<Grid item xs={6}>
											<XsSearchSelect field={this.form.$("title_after")} items={GlobalStore.titleCL} />
										</Grid>
										<Grid item container spacing={24}>
											<Grid item xs={6}>
												<XsSearchSelect field={this.form.$("gender")} items={GlobalStore.genderCL} />
											</Grid>
										</Grid>
										<Grid item xs={6}>
											<XsInput field={this.form.$("company_identifier")} />
										</Grid>
										<Grid item xs={6}>
											<XsInput field={this.form.$("company_name")} />
										</Grid>
										<Grid item xs={6}>
											<XsInput field={this.form.$("doctor_code")} />
										</Grid>
										<Grid item xs={6}>
											<XsInput field={this.form.$("provider_code")} />
										</Grid>
										<Grid item xs={6}>
											<XsInput field={this.form.$("dzp_login")} />
										</Grid>
										<Grid item xs={6}>
											<XsInput field={this.form.$("dzp_password")} />
										</Grid>
										<Grid item xs={6}>
											<XsInput field={this.form.$("vszp_login")} />
										</Grid>
										<Grid item xs={6}>
											<XsInput field={this.form.$("vszp_password")} />
										</Grid>
										<Grid item xs={6}>
											<XsInput field={this.form.$("union_login")} />
										</Grid>
										<Grid item xs={6}>
											<XsInput field={this.form.$("union_password")} />
										</Grid>
										<Grid item xs={12}>
											<XsButton
												className="xs-primary"
												text="Mám záujem si ambee vyskúšať"
												onClick={this.form.onSubmit}
											/>
										</Grid>
									</Grid>
								</Grid> */}
								<Grid container justify="center">
									<Grid container item xs={6} direction="column" spacing={24}>
										<Grid item>
											<XsInput field={this.form.$("name")} />
										</Grid>
										<Grid item>
											<XsInput field={this.form.$("code")} />
										</Grid>
										<Grid item>
											<XsInput field={this.form.$("email")} />
										</Grid>
										<Grid item>
											<XsInput field={this.form.$("phone")} />
										</Grid>
										<Grid item style={{fontSize: "14px", fontWeight: "500", color: "#F0F3F8"}}>
											Pre akú ambulanciu potrebujete ambee:
										</Grid>
										<Grid item>
											<XsRadioButtonGroup
												name="types"
												field={this.form.$("ambulance")}
												radioButtons={[
													{
														value: "lekar",
														label: <FormattedMessage id="Common.label.generalDoctor" /> //context.intl.formatMessage({ id: "Patient.form.patientPrescription.firstRadio" })
													},
													{
														value: "specialista",
														label: <FormattedMessage id="Common.label.specialistDoctor" /> // "SECOND", //context.intl.formatMessage({ id: "Patient.form.patientPrescription.secondRadio" }),
														// style: {marginTop: "13px"}
													}
												]}
												onChange={(val) => {
													this.form.$("ambulance").value = val
												}}
											/>
										</Grid>
										<Grid item>
											<XsButton
												className="xs-primary"
												text="Mám záujem si ambee vyskúšať"
												onClick={this.form.onSubmit}
											/>
										</Grid>
									</Grid>
								</Grid>
							</div>
							<div data-jarallax-element="150 257">
								<div className="decoration bottom left scale-3">
									<svg
										className="bg-primary"
										width="257"
										height="200"
										viewBox="0 0 257 200"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M52.4279 199.385C43.0839 199.209 36.3889 195.125 32.1679 186.768C27.0589 176.651 23.0699 166.059 18.5959 155.67C14.4909 146.139 11.7989 136.287 9.8339 126.129C8.3399 118.4 6.2499 110.777 4.2029 103.166C1.6089 93.512 1.1799 83.586 0.327904 73.727C0.0159039 70.11 0.526895 66.342 1.17789 62.735C3.21689 51.438 5.9829 40.346 11.6529 30.198C17.3889 19.928 24.6629 11.067 34.9749 5.09298C41.4319 1.35298 48.4239 -0.117996 55.8949 0.868004C57.9049 1.134 59.9499 1.2 61.9789 1.225C71.0429 1.332 79.9579 2.518 88.7739 4.635C99.0339 7.1 109.327 9.44598 119.891 10.244C124.323 10.578 128.77 10.765 133.196 11.16C142.811 12.017 152.415 13.006 162.03 13.869C169.618 14.551 177.214 15.588 184.811 15.637C194.612 15.698 203.692 17.942 212.225 22.553C219.284 26.367 225.918 30.826 232.161 35.899C237.325 40.096 239.942 45.866 242.524 51.674C245.827 59.108 248.79 66.699 252.278 74.043C253.758 77.166 254.821 80.272 255.723 83.602C258.006 92.018 256.088 99.834 252.858 107.36C247.544 119.743 238.922 129.653 228.809 138.475C223.024 143.522 217.065 148.209 210.334 151.858C201.387 156.712 192.336 161.282 182.279 163.602C175.226 165.229 168.332 167.526 161.322 169.358C150.377 172.221 139.363 174.829 128.441 177.782C124.039 178.973 119.779 180.723 115.502 182.346C108.85 184.867 102.33 187.789 95.5759 189.989C90.2869 191.712 84.7239 192.6 79.2829 193.852C73.0899 195.278 66.9079 196.752 60.6949 198.086C57.9729 198.67 55.1859 198.961 52.4279 199.385ZM2.4139 69.891C2.8909 77.291 2.8549 82.676 3.6699 87.928C4.8339 95.455 6.5329 102.903 8.1679 110.348C9.3969 115.936 11.0959 121.424 12.2069 127.03C13.8459 135.284 15.6869 143.446 19.1909 151.153C20.4529 153.928 21.7179 156.725 22.6929 159.61C25.8409 168.926 30.5069 177.551 34.7049 186.391C37.0959 191.42 40.8749 194.725 46.3479 195.953C47.9519 196.312 49.6189 196.803 51.2149 196.682C54.9999 196.397 58.7989 195.971 62.5239 195.246C66.6369 194.447 70.6199 192.838 74.7529 192.307C87.1079 190.719 98.8939 187.225 110.206 182.157C122.585 176.61 135.595 173.192 148.706 169.997C166.852 165.575 185.198 161.819 202.196 153.577C208.983 150.286 215.481 146.638 221.26 141.774C223.399 139.973 225.467 138.086 227.641 136.329C237.504 128.349 245.12 118.612 250.375 107.075C252.391 102.651 253.904 98.11 252.98 93.059C252.503 90.45 252.259 87.741 252.384 85.1C252.501 82.6 251.993 80.356 251.236 78.032C247.797 67.473 242.777 57.591 238.306 47.475C236.376 43.108 233.327 39.489 229.482 36.631C226.017 34.059 222.412 31.676 218.953 29.096C211.025 23.188 202.168 19.569 192.383 18.366C187.85 17.807 183.258 17.751 178.699 17.372C170.855 16.718 163.011 16.044 155.178 15.274C150.75 14.838 146.356 14.057 141.926 13.686C136.612 13.239 131.27 13.122 125.947 12.75C121.259 12.422 116.533 12.232 111.91 11.461C104.894 10.293 97.9309 8.775 90.9859 7.225C81.2789 5.059 71.5269 3.41799 61.5349 3.57699C59.8899 3.60399 58.2319 3.431 56.5989 3.208C47.8569 2.015 39.8019 4.02999 32.7179 9.07699C24.4229 14.985 18.0729 22.706 13.2099 31.694C9.53991 38.479 7.1459 45.712 5.4439 53.155C4.0329 59.334 3.1679 65.637 2.4139 69.891Z"
											fill="black"
										></path>
									</svg>
								</div>
							</div>

							<div data-jarallax-element="-134 -250">
								<div className="decoration top right scale-2">
									<svg
										className="bg-primary"
										width="134"
										height="201"
										viewBox="0 0 134 201"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M19.0311 0.187012C26.8611 0.808012 34.6931 1.42599 42.5231 2.04999C49.7321 2.62399 56.9391 3.22502 64.1501 3.77802C74.2241 4.55002 84.2811 5.341 94.1581 7.495C101.607 9.12 108.681 11.531 115.408 14.793C119.041 16.555 121.724 19.175 123.398 22.575C126.9 29.69 129.611 37.051 131.277 44.684C131.923 47.641 132.125 50.69 132.326 53.707C132.656 58.628 132.82 63.557 133.055 68.483C133.076 68.931 133.17 69.387 133.119 69.829C131.922 80.168 134.004 90.445 133.836 100.764C133.738 106.83 133.576 112.898 133.553 118.965C133.539 122.334 133.877 125.704 133.834 129.071C133.785 132.772 133.469 136.47 133.289 140.17C133.223 141.517 133.088 142.875 133.203 144.212C134.273 156.666 132.223 168.842 129.215 180.932C127.572 187.536 123.686 192.957 117.936 197.225C116.469 198.314 114.446 199.075 112.557 199.379C106.391 200.374 100.186 200.625 93.9141 199.842C86.9941 198.977 80.0231 198.451 73.0801 197.731C64.3811 196.827 55.8261 195.266 47.4001 193.116C37.3771 190.558 27.8061 187.017 18.8571 182.231C11.6131 178.355 7.67906 172.518 6.92906 164.901C6.45406 160.101 5.59306 155.333 5.10106 150.534C4.80406 147.64 4.95506 144.711 4.75906 141.805C4.66306 140.368 4.19307 138.955 3.98807 137.52C3.86507 136.663 3.78706 135.763 3.93706 134.919C4.37306 132.467 4.69306 130.042 4.16206 127.555C3.92806 126.466 4.08605 125.313 4.02505 124.191C3.56805 115.67 3.11106 107.149 2.63006 98.629C2.37606 94.145 2.10706 89.66 1.77806 85.179C1.54206 81.933 1.05505 78.697 0.928053 75.448C0.633053 67.815 0.391064 60.178 0.311064 52.542C0.260064 47.715 0.647065 42.886 0.643065 38.058C0.639065 33.005 0.22906 27.95 0.31906 22.9C0.40706 18.065 1.10206 13.271 2.88006 8.64801C5.29406 2.37001 8.19106 0.467985 15.6341 0.415985C16.7591 0.406985 17.8841 0.414001 19.0091 0.414001C19.0161 0.337001 19.0231 0.262012 19.0311 0.187012ZM2.56405 47.289C2.58205 47.289 2.59706 47.289 2.61506 47.289C2.61506 54.711 2.60906 62.132 2.62106 69.553C2.62306 70.676 2.59806 71.815 2.78106 72.919C4.98406 86.164 4.96305 99.565 6.19105 112.879C7.07805 122.492 7.03506 132.187 7.08206 141.846C7.11906 149.411 8.04306 156.865 9.29106 164.319C10.5511 171.842 14.8871 177.56 22.0591 181.311C26.7891 183.785 31.8711 185.778 36.9571 187.629C46.9691 191.274 57.4921 193.287 68.1171 194.818C72.1721 195.403 76.3141 195.48 80.3961 195.944C89.7921 197.011 99.1191 198.554 108.697 197.552C113.316 197.069 116.955 195.597 119.98 192.367C123.98 188.095 126.248 183.149 127.394 177.813C129.505 167.986 130.853 158.064 130.783 148.022C130.752 143.525 130.906 139.024 130.781 134.53C130.343 118.696 131.5 102.851 129.836 87.015C129.016 79.215 129.322 71.315 129.246 63.459C129.221 60.885 129.687 58.31 129.766 55.73C129.83 53.607 129.873 51.45 129.543 49.356C128.307 41.527 125.631 34.065 122.475 26.693C120.381 21.806 117.037 18.245 111.858 15.902C100.87 10.932 89.1671 8.376 77.0041 7.311C69.6761 6.67 62.3441 6.07398 55.0101 5.47198C48.2991 4.91998 41.5881 4.36899 34.8751 3.85599C30.6461 3.53199 26.4141 3.193 22.1781 3.021C19.3321 2.906 16.4711 3.018 13.6211 3.125C9.82006 3.27 7.40006 5.27101 5.87106 8.20001C5.13506 9.61201 4.44705 11.127 4.21505 12.654C3.53505 17.098 2.79705 21.563 2.63505 26.036C2.37505 33.115 2.56405 40.205 2.56405 47.289Z"
											fill="black"
										></path>
									</svg>
								</div>
							</div>
						</section>
						{/* <!-- Kontaktny formular --> */}

						{/* <section className="o-hidden">
							<div className="container">
								<div className="row justify-content-center text-center mb-5">
									<div className="col-xl-8 col-lg-9">
										<h2 className="display-4 mx-xl-6">Novinky</h2>
										<p className="lead">
											Pracujeme na mobilnej aplikácii <b>Stella</b>. Po prepojení s am<b>bee </b>
											budete môcť pohodlne zasielať pacientom upozornenia o zmenách a dôležitých informáciách z vašej
											ambulancie. Pacienti si budú vedieť naplánovať návštevu či požiadať o predpis lieku, ktorý
											užívajú.
										</p>
									</div>
								</div>
								<div className="row">
									<div className="col">
										<div className="slider-phone">
											<img src="public/images/iphone-xr.svg" alt="Phone" className="col-9 col-md-5 col-lg-4 col-xl-3" />
											<div data-flickity='{ "imagesLoaded": true, "wrapAround": true }'>
												<div className="carousel-cell col-9 col-md-5 col-lg-4 col-xl-3 mx-4">
													<img
														src="public/images/ambee-stella-ehr.jpg"
														alt="Elektronická zdravotná karta dostupná kedykoľvek a kdekoľvek."
													/>
												</div>
												<div className="carousel-cell col-9 col-md-5 col-lg-4 col-xl-3 mx-4">
													<img src="public/images/ambee-stella-calendar.jpg" alt="Plánujte spolu s pacientom. " />
												</div>
												<div className="carousel-cell col-9 col-md-5 col-lg-4 col-xl-3 mx-4">
													<img
														src="public/images/ambee-stella-refills.jpg"
														alt="Doplňte lieky, ak to pacient potrebuje."
													/>
												</div>
												<div className="carousel-cell col-9 col-md-5 col-lg-4 col-xl-3 mx-4">
													<img src="public/images/ambee-stella-login.jpg" alt="Spolu s vami chránime vaše dáta. " />
												</div>
												<div className="carousel-cell col-9 col-md-5 col-lg-4 col-xl-3 mx-4">
													<img
														src="public/images/ambee-stella-recentPatient.jpg"
														alt="Manažujte pacianta na diaľku. "
													/>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</section> */}
						{/* <!-- Mobile Screen Shots --> */}

						{/* <section>
							<div className="container">
								<div className="row justify-content-center text-center">
									<div className="col-lg-8 col-md-10">
										<h3 className="display-4">Zaujala vás Stella?</h3>
										<p>
											Ak chcete dostávať najnovšie informácie o aplikácii Stella, pošleme vám ich každý mesiac. Ak
											budete chcieť, radi vás zapojíme do pilotného overenia od apríla 2020.
										</p>
										<small className="text-muted form-text">
											Vaše údaje nebudeme nikdy zdielať. Pozrite si naše
											<a
												className="pointer blueColor"
												onClick={() => {
													RouterStore.push("./dokumentacia")
													UIStore.dokumentacia = "podmienkyPouzivania"
												}}
											>
												{" Podmienky používania"}
											</a>
											.
										</small>
									</div>
								</div>
							</div>
						</section> */}
						{/* <form
              action="/forms/stella-news-register.php"
              data-form-email
              novalidate
            >
              <div className="form-row">
                <div className="col-6">
                  <input
                    type="email"
                    className="form-control mb-2"
                    placeholder="peter.trebeja@spire.sk"
                    name="email"
                    required
                  />
                </div>
                <div className="col-6">
                  <button
                    type="submit"
                    className="btn btn-primary btn-loading btn-block"
                    data-loading-text="Sending"
                  >
                    <svg
                      className="icon"
                      width="24px"
                      height="24px"
                      viewBox="0 0 24 24"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                      <title>Loading...</title>
                      <g
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                      >
                        <g>
                          <polygon
                            points="0 0 24 0 24 24 0 24"
                            opacity="0"
                          ></polygon>
                        </g>
                        <path
                          d="M12,4 L12,6 C8.6862915,6 6,8.6862915 6,12 C6,15.3137085 8.6862915,18 12,18 C15.3137085,18 18,15.3137085 18,12 C18,10.9603196 17.7360885,9.96126435 17.2402578,9.07513926 L18.9856052,8.09853149 C19.6473536,9.28117708 20,10.6161442 20,12 C20,16.418278 16.418278,20 12,20 C7.581722,20 4,16.418278 4,12 C4,7.581722 7.581722,4 12,4 Z"
                          fill="#000000"
                          fill-rule="nonzero"
                          transform="translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, -12.000000) "
                        ></path>
                      </g>
                    </svg>
                    <span>Posielajte mi novinky</span>
                  </button>
                  <div
                    className="d-none alert alert-success mt-3"
                    role="alert"
                    data-success-message
                  >
                    Ďakujeme, náš tím sa s vami čoskoro spojí.
                  </div>
                  <div
                    className="d-none alert alert-danger mt-3"
                    role="alert"
                    data-error-message
                  >
                    Prosíme, vyplňte všetky polia správne.
                  </div>
                  <div
                    data-recaptcha
                    data-sitekey="INSERT_YOUR_RECAPTCHA_V2_SITEKEY_HERE"
                    data-size="invisible"
                    data-badge="bottomleft"
                  ></div>
                </div>
              </div>
            </form> */}
						{/* <!-- Sign Up for stella news --> */}

						<footer className="pb-5 bg-primary text-light">
							<div className="container">
								<div className="row mb-4 justify-content-center">
									<div className="col-auto">
										<img
											className="pointer"
											onClick={() => RouterStore.push("./")}
											src="public/images/logo-white.png"
											alt="ambee DIGITÁLNY ASISTENT"
											title="ambee | Moderný ambulatný systém"
										/>
									</div>
								</div>
								<div className="row mb-4">
									<div className="col">
										<ul className="nav justify-content-center">
											<li className="nav-item">
												<a className="nav-link pointer" onClick={() => UIStore.scrollTo(UIStore.vyhodyRef.offsetTop)}>
													Výhody
												</a>
											</li>
											<li className="nav-item">
												<a
													className="nav-link pointer"
													onClick={() => {
														RouterStore.push("./dokumentacia")
														UIStore.dokumentacia = ""
													}}
												>
													Dokumentácia
												</a>
											</li>
											<li className="nav-item">
												<a className="nav-link pointer" onClick={() => RouterStore.push("./referencie")}>
													Referencie
												</a>
											</li>
											<li className="nav-item">
												<a className="nav-link pointer" onClick={() => UIStore.scrollTo(UIStore.cennikRef.offsetTop)}>
													Cenník
												</a>
											</li>
											<li className="nav-item">
												<a
													onClick={() => {
														RouterStore.push("./dokumentacia")
														UIStore.dokumentacia = "podmienkyPouzivania"
													}}
													className="nav-link pointer"
												>
													Podmienky používania
												</a>
											</li>
											<li className="nav-item">
												<a className="nav-link">
													HELP DESK <b>+421 911 34 19 19</b>
												</a>
											</li>
										</ul>
									</div>
								</div>
								<div className="row justify-content-center mt-5 mb-5">
									<div className="col-auto">
										<ul className="nav">
											<li className="nav-item">
												<a
													href="https://www.instagram.com/ambee.sk/"
													className="nav-link"
													target="_blank"
													rel="noopener noreferrer"
													title="Sledujte ambee na Instagrame. "
												>
													<svg
														className="icon undefined"
														role="img"
														viewBox="0 0 24 24"
														xmlns="http://www.w3.org/2000/svg"
													>
														<title>Instagram</title>
														<path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z" />
													</svg>
												</a>
											</li>
											<li className="nav-item">
												<a
													href="https://twitter.com/ambee37093576"
													className="nav-link"
													target="_blank"
													rel="noopener noreferrer"
													title="Sledujte ambee na Twitteri. "
												>
													<svg
														className="icon undefined"
														role="img"
														viewBox="0 0 24 24"
														xmlns="http://www.w3.org/2000/svg"
													>
														<title>Twitter</title>
														<path d="M23.954 4.569c-.885.389-1.83.654-2.825.775 1.014-.611 1.794-1.574 2.163-2.723-.951.555-2.005.959-3.127 1.184-.896-.959-2.173-1.559-3.591-1.559-2.717 0-4.92 2.203-4.92 4.917 0 .39.045.765.127 1.124C7.691 8.094 4.066 6.13 1.64 3.161c-.427.722-.666 1.561-.666 2.475 0 1.71.87 3.213 2.188 4.096-.807-.026-1.566-.248-2.228-.616v.061c0 2.385 1.693 4.374 3.946 4.827-.413.111-.849.171-1.296.171-.314 0-.615-.03-.916-.086.631 1.953 2.445 3.377 4.604 3.417-1.68 1.319-3.809 2.105-6.102 2.105-.39 0-.779-.023-1.17-.067 2.189 1.394 4.768 2.209 7.557 2.209 9.054 0 13.999-7.496 13.999-13.986 0-.209 0-.42-.015-.63.961-.689 1.8-1.56 2.46-2.548l-.047-.02z" />
													</svg>
												</a>
											</li>
											<li className="nav-item">
												<a
													href="https://www.youtube.com/channel/UCXDnyXYI_kNUAvPuSBmnR5A"
													className="nav-link"
													target="_blank"
													rel="noopener noreferrer"
													title="Otvoriť náš YouTube kanál. "
												>
													<svg
														className="icon undefined"
														role="img"
														xmlns="http://www.w3.org/2000/svg"
														viewBox="0 0 24 24"
													>
														<title>YouTube icon</title>
														<path
															className="a"
															d="M23.495 6.205a3.007 3.007 0 0 0-2.088-2.088c-1.87-.501-9.396-.501-9.396-.501s-7.507-.01-9.396.501A3.007 3.007 0 0 0 .527 6.205a31.247 31.247 0 0 0-.522 5.805 31.247 31.247 0 0 0 .522 5.783 3.007 3.007 0 0 0 2.088 2.088c1.868.502 9.396.502 9.396.502s7.506 0 9.396-.502a3.007 3.007 0 0 0 2.088-2.088 31.247 31.247 0 0 0 .5-5.783 31.247 31.247 0 0 0-.5-5.805zM9.609 15.601V8.408l6.264 3.602z"
														/>
													</svg>
												</a>
											</li>
											<li className="nav-item">
												<a
													href="https://www.facebook.com/ambee.sk/"
													className="nav-link"
													target="_blank"
													rel="noopener noreferrer"
													title="Sleduje ambee na Facebooku. "
												>
													<svg
														className="icon undefined"
														role="img"
														viewBox="0 0 24 24"
														xmlns="http://www.w3.org/2000/svg"
													>
														<title>Facebook icon</title>
														<path d="M22.676 0H1.324C.593 0 0 .593 0 1.324v21.352C0 23.408.593 24 1.324 24h11.494v-9.294H9.689v-3.621h3.129V8.41c0-3.099 1.894-4.785 4.659-4.785 1.325 0 2.464.097 2.796.141v3.24h-1.921c-1.5 0-1.792.721-1.792 1.771v2.311h3.584l-.465 3.63H16.56V24h6.115c.733 0 1.325-.592 1.325-1.324V1.324C24 .593 23.408 0 22.676 0" />
													</svg>
												</a>
											</li>
										</ul>
									</div>
								</div>
								{/* <!-- social --> */}
								<div className="row justify-content-center text-center">
									<div className="col-xl-10">
										<small className="text-muted">
											&copy;2018 - {new Date().getFullYear()} All Rights Reserved. am<b>bee</b> is a registered
											trademark of <b>SPIRE LIFE SOLUTION s.r.o.</b> Apple and the Apple logo are trademarks of Apple
											Inc., registered in the U.S. and other countries. Mac App Store is a service mark of Apple Inc.
											Google Play and the Google Play logo are trademarks of Google Inc.
										</small>
									</div>
								</div>
							</div>
						</footer>
					</React.Fragment>
				)}
			</React.Fragment>
		)
	}
}

{
	/* // <Grid container direction="column" spacing={16}>
		// 	{this.renderContent()}
		// 	<Grid item className="pt-4">
		// 		<XsButton
		// 			className="xs-primary"
		// 			text={<FormattedMessage id="Common.label.login" />}
		// 			onClick={this.form.onSubmit}
		// 		/>
		// 	</Grid>
		// </Grid> */
}

